/** Pure choice logic for vanilla-style rain sounds (sampled drops near the player). */
export const RAIN_SOUND_RADIUS = 10;
export const RAIN_TICK = 0.05; // 20 Hz

export type RainPrecip = 'rain' | 'snow' | 'none';

/** Chance per 20 Hz tick that a rain sample is started; scales with rain strength. */
export function rainTickChance(strength: number): number {
  const s = Math.max(0, Math.min(1, strength));
  return s < 0.02 ? 0 : 0.35 * s;
}

export interface RainSoundChoice { id: 'weather.rain' | 'weather.rain.above'; volume: number; pitch: number }

/**
 * Which sample for a column surface at `spotY`: full `weather.rain` when the player is under open sky
 * and the spot is level or below / near; muffled `weather.rain.above` (lower, duller) when covered
 * or the spot is well above. null = nothing to hear (snow, dry biome).
 */
export function rainSoundFor(precip: RainPrecip, playerExposed: boolean, spotY: number, playerY: number): RainSoundChoice | null {
  if (precip !== 'rain') return null;
  if (!playerExposed || spotY > playerY + 10) return { id: 'weather.rain.above', volume: 0.1, pitch: 0.5 };
  return { id: 'weather.rain', volume: 0.2, pitch: 1 };
}
